import _ from "lodash";
import moment from "moment";
import template from "./spray_homescreen_section.html";
import en from "./en.json";
import es from "./es.json";
import {
    sprayApplicationRecordState,
    sprayStartSprayState,
} from "../../../../base.routes";
import { SID_LOOKUP } from "../../../../app.constants";
import { getApplicationRecordLocationDescription } from "../../application_record_fields.utils";
import {
    SPRAY_APPLICATION_RECORD_STATUSES,
    getSprayApplicationRecordStatusTextClass,
} from "../../constants";

class SprayHomescreenSectionController {
    /* @ngInject */
    constructor(ApplicationRecordService, FieldService, $interval, $q) {
        this.ApplicationRecordService = ApplicationRecordService;
        this.FieldService = FieldService;
        this.$interval = $interval;
        this.$q = $q;
    }

    $onInit() {
        let ctrl = this;
        ctrl.inProgressSprays = [];
        ctrl.notStartedSprays = [];
        ctrl.scheduledStatusClass = getSprayApplicationRecordStatusTextClass(
            SPRAY_APPLICATION_RECORD_STATUSES.SCHEDULED,
        );
        ctrl.inProgressStatusClass = getSprayApplicationRecordStatusTextClass(
            SPRAY_APPLICATION_RECORD_STATUSES.IN_PROGRESS,
        );
        ctrl.sprayApplicationRecordState = sprayApplicationRecordState;
        ctrl.sprayStartSprayState = sprayStartSprayState;

        ctrl.pollInProgressSprays();
        ctrl.pollNotStartedSprays();
        ctrl.pollingIntervalId = ctrl.$interval(function () {
            ctrl.pollInProgressSprays();
            ctrl.pollNotStartedSprays();
        }, 30000);
    }

    getFieldsBySidForRecords(records) {
        let ctrl = this;
        let fieldSids = _.uniq(
            _.flatten(
                _.map(records || [], function (record) {
                    return record.fields;
                }),
            ),
        );

        if (!fieldSids.length) {
            return ctrl.$q.when({});
        }

        return ctrl.FieldService.several(fieldSids)
            .then(function (fields) {
                return _.keyBy(fields, SID_LOOKUP);
            })
            .catch(function () {
                return {};
            });
    }

    normalizeApplicationRecords(records, fieldsBySid) {
        return _.map(records || [], function (record) {
            return _.assign({}, record, {
                locationDescription: getApplicationRecordLocationDescription(
                    record,
                    fieldsBySid || {},
                ),
            });
        });
    }

    getTargetStartDateSortValue(record) {
        let targetStartDate = record ? record.target_start_date : null;
        if (!targetStartDate) {
            return Number.MAX_SAFE_INTEGER;
        }

        let targetStartMoment = moment(targetStartDate);
        if (!targetStartMoment.isValid()) {
            return Number.MAX_SAFE_INTEGER;
        }

        return targetStartMoment.valueOf();
    }

    hasVisibleSprays() {
        let ctrl = this;
        return (
            (ctrl.notStartedSprays || []).length +
                (ctrl.inProgressSprays || []).length >
            0
        );
    }

    pollInProgressSprays() {
        let ctrl = this;

        if (!ctrl.grower || !ctrl.myGrowerMembership) {
            ctrl.inProgressSprays = [];
            return;
        }

        return ctrl.ApplicationRecordService.list(
            {
                active: true,
                grower_organization__sid: ctrl.grower.sid,
                applicator__sid: ctrl.myGrowerMembership.sid,
                start_date__isnull: false,
                end_date__isnull: true,
            },
            {
                orderBy: "start_date",
                ascending: false,
            },
        )
            .then(function (records) {
                return ctrl
                    .getFieldsBySidForRecords(records)
                    .then(function (fieldsBySid) {
                        return ctrl.normalizeApplicationRecords(
                            records,
                            fieldsBySid,
                        );
                    });
            })
            .then(function (records) {
                ctrl.inProgressSprays = records;
            })
            .catch(function () {
                ctrl.inProgressSprays = [];
            });
    }

    pollNotStartedSprays() {
        let ctrl = this;

        if (!ctrl.grower || !ctrl.myGrowerMembership) {
            ctrl.notStartedSprays = [];
            return;
        }

        return ctrl.ApplicationRecordService.list(
            {
                active: true,
                grower_organization__sid: ctrl.grower.sid,
                assigned_applicator__sid: ctrl.myGrowerMembership.sid,
                start_date__isnull: true,
                end_date__isnull: true,
            },
            {
                orderBy: "target_start_date",
                ascending: true,
            },
        )
            .then(function (records) {
                return ctrl
                    .getFieldsBySidForRecords(records)
                    .then(function (fieldsBySid) {
                        return ctrl.normalizeApplicationRecords(
                            records,
                            fieldsBySid,
                        );
                    });
            })
            .then(function (records) {
                ctrl.notStartedSprays = records.sort(
                    function (leftRecord, rightRecord) {
                        return (
                            ctrl.getTargetStartDateSortValue(leftRecord) -
                            ctrl.getTargetStartDateSortValue(rightRecord)
                        );
                    },
                );
            })
            .catch(function () {
                ctrl.notStartedSprays = [];
            });
    }

    $onDestroy() {
        let ctrl = this;
        if (ctrl.pollingIntervalId) {
            ctrl.$interval.cancel(ctrl.pollingIntervalId);
            ctrl.pollingIntervalId = null;
        }
    }
}

export default {
    name: "sprayHomescreenSection",
    template: template,
    controller: SprayHomescreenSectionController,
    bindings: {
        grower: "<",
        myGrowerMembership: "<",
    },
    translations: { en, es },
};
